import { useEffect } from "react";
import { useQuery, type UseQueryOptions } from "@tanstack/react-query";

import { toast } from "@/shared/hooks/use-toast";

import { templatesApi } from "../api";
import type { TemplateRecord } from "../api";
import { templateKeys } from "./template.keys";

export function useTemplate(
  id?: string,
  options?: Omit<UseQueryOptions<TemplateRecord, Error>, "queryKey" | "queryFn">,
) {
  const queryKey = id ? templateKeys.detail(id) : [...templateKeys.details(), ""];
  const query = useQuery({
    queryKey,
    queryFn: ({ signal }) => {
      if (!id) throw new Error("ID do template não informado");
      return templatesApi.get(id, signal);
    },
    enabled: Boolean(id),
    ...(options as Omit<UseQueryOptions<TemplateRecord, Error>, "queryKey" | "queryFn">),
  });

  useEffect(() => {
    if (!query.error) return;
    toast({
      title: "Erro ao carregar template",
      description: query.error.message,
      variant: "destructive",
    });
  }, [query.error]);

  return {
    template: query.data ?? null,
    isLoading: query.isLoading,
    isFetching: query.isFetching,
    error: query.error,
    refetch: query.refetch,
    queryResult: query,
  };
}
